import { ComponentProps, FC, ReactElement, useCallback } from 'react'

import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import Button from 'components/features/pfm/Button/Button'
import { createRewardsPaneActionChangeBuyModeStepState } from 'components/features/rewards/rewardsPane/store/actions/paneState'
import { CRYPTO_REWARDS_BUY_MODE_STEP_INVESTMENTS_AMOUNT } from 'components/features/rewards/rewardsPane/constants/paneSteps'

type InvestCryptoButtonProps = {
  theme?: ComponentProps<typeof Button>['theme']
}

export const InvestCryptoButton: FC<InvestCryptoButtonProps> = ({
  theme,
}): ReactElement => {
  const dispatch = useStoreDispatch()
  const openBuyCryptoPane = useCallback(() => {
    const actionOpenInvestmentsAmountStep = createRewardsPaneActionChangeBuyModeStepState({
      step: CRYPTO_REWARDS_BUY_MODE_STEP_INVESTMENTS_AMOUNT,
      progressPercents: 20,
    })
    dispatch(actionOpenInvestmentsAmountStep)
  }, [dispatch])

  return <Button theme={ theme } fullWidth onClick={ openBuyCryptoPane }>Invest</Button>
}
